import React, { ReactElement } from "react";
import Head from "next/head";
import getConfig from "next/config";
import { MainLayout } from "@/containers/layout/KoachLayout";
import ArticleContent from "@/components/koach/Guides/Blog/components/ArticleContent";
import Signup from "@/components/koach/Signup";
import { Guide } from "@/services/cms/apiTypes";
import routes from "@/constants/routes";
import { getGuides } from "@/services/cms/api";

interface GuideProps {
  guide: Guide;
}

const GuidePage = ({ guide }: GuideProps): JSX.Element => {
  return (
    <>
      <Head>
        <title>{guide.attributes.title}</title>
        <link
          rel="canonical"
          href={`https://www.klink-app.com/guides/${guide.attributes.slug}`}
        />
        <meta name="description" content={guide.attributes.description} />
        <meta name="twitter:url" content="https://www.klink-app.com/guides" />
        <meta
          name="twitter:title"
          content="Guides for Saving & Spending Smarter with Klink"
        />
        <meta name="twitter:image" content="/meta-opengraph-landing.png" />
        <meta name="twitter:creator" content="klink_app" key="twhandle" />
        <meta property="og:url" content="/" key="ogurl" />
        <meta
          property="og:image"
          content="/meta-opengraph-guide.png"
          key="ogimage"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Klink" key="ogsitename" />
        <meta
          property="og:title"
          content="Guides for Saving & Spending Smarter with Klink"
          key="ogtitle"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_GB" />
        <meta
          property="og:description"
          content={guide.attributes.description}
          key="ogdesc"
        />
      </Head>
      <div className="bg-white">
        <ArticleContent guide={guide} baseUrl={routes.guides} />
        <Signup />
      </div>
    </>
  );
};

GuidePage.getLayout = function getLayout(page: ReactElement) {
  return (
    <>
      <MainLayout theme="dark">{page}</MainLayout>
    </>
  );
};

export default GuidePage;

export async function getServerSideProps(context: any) {
  const { slug } = context.query;
  const guideResponse = await getGuides({
    populate: [
      "category",
      "tags",
      "relatedGuides",
      "relatedGuides.category",
      "relatedGuides.cover",
      "cover",
      "author",
    ],
    filters: {
      slug: {
        $eq: slug,
      },
    },
  });

  if (guideResponse.data.length === 1) {
    return {
      props: { guide: guideResponse.data[0] },
    };
  }
  return {
    notFound: true,
  };
}
